import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface ICommonFilterFormMeta {
    agency: FormInputMeta;
    customer: FormInputMeta;

    schema: any;
}

const commonFilterFormMeta = {} as ICommonFilterFormMeta;

commonFilterFormMeta.agency = {
    name: "agency",
    type: "select",
    label: "Agence",
    placeholder: "Agence",
    validation: yup.string(),
};

commonFilterFormMeta.customer = {
    name: "customer",
    type: "select",
    label: "Client",
    placeholder: "Client",
    validation: yup.string(),
};

commonFilterFormMeta.schema = yup.object().shape(getValidationSchema(commonFilterFormMeta));

export default commonFilterFormMeta;